import React from 'react';

function EligibilityReportSummary({ viewReportData }) {
  const histryPrsnt = {
    background: '#f2f2f2 none repeat scroll 0 0',
    borderBottom: '1px solid #eae8e8',
    borderTop: '1px solid #eae8e8',
    color: '#00521d',
    float: 'left',
    fontSize: '14px',
    fontVariant: 'smallCaps',
    height: '29px',
    margin: '4px 0 0 0',
    padding: '5px 1% 1px',
    width: '98%',

    marginBottom: '2px',
    marginTop: '0px',
  };

  return (
    <>
      <div className="left width100 one-edge-shadow clear-bottom" style={{}}>
        <div className="" style={histryPrsnt}>
          <span className="hpi-heading">Payer information:</span>
        </div>
        <div
          className="left width100"
          style={{ paddingBottom: '10px', display: 'flex' }}
        >
          <div className="left elig-reprt-con-lft">
            <div
              className="era-pos-pyrnm-blk width100"
              style={{
                float: 'left',
                width: '190px',
                padding: '10px 0px 0px 10px',
                color: '#717171',
              }}
            >
              <span
                className="elig-reprt-pyrnm-lbl1"
                style={{
                  float: 'left',
                  width: '190px',
                  padding: '10px 0px 0px 10px',
                  color: '#717171',
                  display: 'inline-block',
                }}
              >
                Payer name:
              </span>
              <span
                className="elig-reprt-pyrnm-val1"
                style={{
                  float: 'left',
                  paddingTop: '10px',
                  paddingRight: '10px',
                  //width: '23%',
                  display: 'inline-block',
                }}
              >
                {/*<?php echo $eligibilityData['eligPayerName']; ?>*/}
                {viewReportData?.eligPayerName}
              </span>
            </div>
          </div>
          <div className="left elig-reprt-con-rgt">
            <div
              className="era-pos-pyrnm-blk width100"
              style={{
                float: 'left',
                //width: '23%',
              }}
            >
              <span
                className="elig-reprt-pyrnm-lbl2"
                style={{
                  float: 'left',
                  width: '180px',
                  padding: '20px 0px 0px 10px',
                  color: '#717171',
                  display: 'inline-block',
                }}
              >
                Payor identification:
              </span>
              <span
                className="elig-reprt-pyrnm-val2"
                style={{
                  float: 'left',
                  paddingTop: '20px',
                  paddingRight: '15px',
                  // width: '20%',
                  display: 'inline-block',
                }}
              >
                {/*<?php echo $eligibilityData['eligPiNum']; ?>*/}
                {viewReportData?.eligPiNum}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="left width100 one-edge-shadow clear-bottom">
        <div className="" style={histryPrsnt}>
          <span className="hpi-heading">Provider information:</span>
        </div>
        <div className="left " style={{ paddingBottom: '10px' }}>
          <div className="left elig-reprt-con-lft">
            <div className="era-pos-pyrnm-blk width100">
              <span className="elig-reprt-pyrnm-lbl1">
                Provider name:{viewReportData?.eligProvLastName}
              </span>
              <span className="elig-reprt-pyrnm-val1">
                {/*	<?php echo $eligibilityData['eligProvLastName']." ".
                    $eligibilityData['eligProvFirstName']; ?>*/}
              </span>
            </div>
          </div>
          <div className="left elig-reprt-con-rgt">
            <div className="era-pos-pyrnm-blk width100">
              <span className="elig-reprt-pyrnm-lbl2">
                Health care financing administration NPI:{' '}
                {viewReportData?.eligProvIdCode}
              </span>
              <span className="elig-reprt-pyrnm-val2">
                {/*	<?php echo $eligibilityData['eligProvIdCode']; ?>*/}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="left width100 one-edge-shadow clear-bottom">
        <div className="" style={histryPrsnt}>
          <span className="hpi-heading">
            Insured or Subscriber Information:
          </span>
        </div>
        <div className="left width100" style={{ paddingBottom: '10px' }}>
          <div className="left elig-reprt-con-lft">
            <div className="era-pos-pyrnm-blk width100">
              <span className="elig-reprt-pyrnm-lbl1">
                Insured or Subscriber name: {viewReportData?.subsLName}{' '}
                {viewReportData?.subsFName}
              </span>
              <span className="elig-reprt-pyrnm-val1">
                {/*<?php echo $eligibilityData['subsLName'].", ".$eligibilityData['subsFName']; ?>*/}
              </span>
            </div>
          </div>
          <div className="left elig-reprt-con-rgt">
            <div className="era-pos-pyrnm-blk width100">
              <span className="elig-reprt-pyrnm-lbl2">
                Member Identification Number: {viewReportData?.subsIdCode}
              </span>
              <span className="elig-reprt-pyrnm-val2">
                {/*<?php echo $eligibilityData['subsIdCode']; ?>*/}
              </span>
            </div>
          </div>
        </div>
        <div className="left width100" style={{ paddingBottom: '10px' }}>
          <div className="left elig-reprt-con-lft">
            <div className="era-pos-pyrnm-blk width100">
              <span className="elig-reprt-pyrnm-lbl1">
                Group Number: {viewReportData?.subsGroupNum}
              </span>
              <span className="elig-reprt-pyrnm-val1">
                {/*<?php 
                                echo $eligibilityData['subsGroupNum'];
                            ?>*/}
              </span>
            </div>
          </div>
          <div className="left elig-reprt-con-rgt">
            <div className="era-pos-pyrnm-blk width100">
              <span className="elig-reprt-pyrnm-lbl2">Address:</span>
              <span className="elig-reprt-pyrnm-val2">
                {viewReportData?.subsAddLine1}{' '}
                {viewReportData?.subsAddLine2 &&
                Object.keys(viewReportData.subsAddLine2).length > 0
                  ? viewReportData.subsAddLine2
                  : null}
              </span>
            </div>
          </div>
        </div>
        <div className="left width100" style={{ paddingBottom: '10px' }}>
          <div className="left elig-reprt-con-lft">
            <div className="era-pos-pyrnm-blk width100">
              <span className="elig-reprt-pyrnm-lbl1">Address 2:</span>
              <span className="elig-reprt-pyrnm-val1">
                {viewReportData?.subsAddCity}
                {', '}
                {viewReportData?.subsAddStateCode &&
                Object.keys(viewReportData.subsAddStateCode).length > 0
                  ? viewReportData.subsAddStateCode
                  : null}{' '}
                {','}
                {viewReportData?.subsAddPostalCode &&
                Object.keys(viewReportData.subsAddPostalCode).length > 0
                  ? viewReportData.subsAddPostalCode
                  : null}
              </span>
            </div>
          </div>
          <div className="left elig-reprt-con-rgt">
            <div className="era-pos-pyrnm-blk width100">
              <span className="elig-reprt-pyrnm-lbl2">Birth Date:</span>
              <span className="elig-reprt-pyrnm-val2">
                {viewReportData.subsDob && (
                  <span>{viewReportData.subsDob.toString()}</span>
                )}
              </span>
            </div>
          </div>
        </div>
        <div className="left width100" style={{ paddingBottom: '10px' }}>
          <div className="left elig-reprt-con-lft">
            <div className="era-pos-pyrnm-blk width100">
              <span className="elig-reprt-pyrnm-lbl1">Gender:</span>
              <span className="elig-reprt-pyrnm-val1">
                {viewReportData.subsGender === 'M' ? (
                  <span>Male</span>
                ) : viewReportData.subsGender === 'F' ? (
                  <span>Female</span>
                ) : null}
              </span>
            </div>
          </div>
          <div className="left elig-reprt-con-rgt">
            <div className="era-pos-pyrnm-blk width100">
              <span className="elig-reprt-pyrnm-lbl2">Plan Begin Date:</span>
              <span className="elig-reprt-pyrnm-val2"></span>
            </div>
          </div>
        </div>
        <div className="left width100" style={{ paddingBottom: '10px' }}>
          <div className="left elig-reprt-con-lft">
            <div className="era-pos-pyrnm-blk width100">
              <span className="elig-reprt-pyrnm-lbl1">
                Relationship with Insured:
              </span>
              <span className="elig-reprt-pyrnm-val1">
                {viewReportData.subsType === '0' ? <span>Self</span> : null}
              </span>
            </div>
          </div>
          <div className="left elig-reprt-con-rgt">
            <div className="era-pos-pyrnm-blk width100">
              <span className="elig-reprt-pyrnm-lbl2">
                Primary Care Provider Name:
              </span>
              <span className="elig-reprt-pyrnm-val2">NA</span>
            </div>
          </div>
        </div>
        <div className="left width100" style={{ paddingBottom: '10px' }}>
          <div className="left elig-reprt-con-lft">
            <div className="era-pos-pyrnm-blk width100">
              <span className="elig-reprt-pyrnm-lbl1">Service Date:</span>
              <span className="elig-reprt-pyrnm-val1">
                {/*<?php echo $this->utilities->showDateForSpecificTimeZone(date('Y-m-d', strtotime($eligibilityData['eligServDate']))); ?>*/}
                {viewReportData.eligServDate}
              </span>
            </div>
          </div>
          <div className="left elig-reprt-con-rgt">
            <div className="era-pos-pyrnm-blk width100">
              <span className="elig-reprt-pyrnm-lbl2">
                Payer Subscriber Trace #:
              </span>
              <span className="elig-reprt-pyrnm-val2">
                {/*<?php echo $eligibilityData['subsTraceNumber']; ?>*/}
                {viewReportData.subsTraceNumber}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default EligibilityReportSummary;
